import Entity from '@/models/entities/Entity';
import { Size } from '@/models/entities/Size';
import { ProductCategoryOption } from '@/models/entities/ProductCategoryOption';
import { ProductCategoryAttribute } from '@/models/entities/ProductCategoryAttribute';
import { ShopifyProduct } from '@/models/entities/ShopifyProduct';
import { ImageFile } from '@/models/entities/ImageFile';
import { Location } from '@/models/entities/Location';
import { CategoryPreview } from '@/models/entities/Category';
import { FontGroup } from '@/models/entities/FontGroup';
import { ColorGroup } from './ColorGroup';

export class Product implements Entity {
  public id: number = 0;
  public originalProduct: string = '';
  public name: string = '';
  public thumbImage: ImageFile = new ImageFile({});
  public description: string = '';
  public categories: CategoryPreview[] = [];
  public position: number = 0;
  public locations: Location[] = [];
  public sizes: Size[] = [];
  public productCategoryOptions: ProductCategoryOption[] = [];
  public productCategoryAttributes: ProductCategoryAttribute[] = [];
  public shopifyProduct: ShopifyProduct = new ShopifyProduct({});
  public colorGroupIds?: number[];
  public fontGroup?: FontGroup;
  public active: boolean = true;
  public logoPlacements?: string[] = ['Front', 'Back', 'Sides'];
  public colorGroup?: ColorGroup | null;

  constructor(initData: Partial<Product>) {
    Object.assign(this, initData);
  }
}
